import { Pagination, Sort, SORT_ENUM } from './../../../core/models/team-management.model';
import { Component, Output, EventEmitter, Input, HostListener, ElementRef, ViewChild } from '@angular/core';

import { SnackbarService } from '../snackbar/service/snackbar.service';
import { listOptions } from 'src/app/core/constants/team-management-const';
interface SortItemsEvent {
  sortData: Sort;
}

interface MemberEmit {
  id: string | number;
  user_id?: string;
  name: string;
  nickname: string;
  userLabel?: string;
  select?: boolean;
  type?: string;
  option?: string;
}

@Component({
  selector: 'app-team-management-table',
  templateUrl: './team-management-table.html',
  styleUrls: ['./team-management-table.scss'],
})
export class TeamManagementTableComponent {

  @Output() public sendIndex = new EventEmitter<number>();
  @Output() public searchMore = new EventEmitter<Pagination>();
  @Output() public sendOptions = new EventEmitter<MemberEmit>();
  @Output() public sendSelections = new EventEmitter<MemberEmit>();
  @Output() public sendItemSelections = new EventEmitter<MemberEmit>();
  @Output() public sortItems = new EventEmitter<SortItemsEvent>();

  @Input() public sortKey: number;
  @Input() public listHeaders = [];
  @Input() public listBinding = [];
  @Input() public searching = false;
  @Input() public positioType = false;
  @Input() public isHoverTable = false;

  @ViewChild('container') container: ElementRef;

  public index = -1;
  public id: number;
  public isSelect = false;
  public isOptions = false;
  public templateIndex = true;
  public currentPage = 1;
  public pageItems = 20;
  public listOptions = listOptions;
  public sortType = { 1: SORT_ENUM.DESC, 2: SORT_ENUM.ASC };

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    this.templateIndex = true;
    if (this.templateIndex) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.templateIndex = false;
      }
    }
  }

  constructor(
    private snackService: SnackbarService,
    private eRef: ElementRef
  ) { }

  public hoverIndex(data: Event) {
    if (data) {
      this.templateIndex = true;
    }
  }

  public hoverEvent(event: number) {
    this.id = event;
  }

  public copyToClipboard(item: string, type: string): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
    this.snackService.show(`${type} copiado`, 'success');
  }

  public getScroll(event: Event | any) {
    event.preventDefault();
    const heigth = ((100 * event.srcElement.scrollTop) / (event.srcElement.scrollHeight - event.srcElement.clientHeight));
    if (heigth === 100) {
      this.index += 1;
    }

    if (this.container.nativeElement.offsetHeight + this.container.nativeElement.scrollTop >= this.container.nativeElement.scrollHeight) {
      const element = this.container.nativeElement;
      this.searchMore.emit(element);
    }
  }

  public selectAll() {
    this.templateIndex = true;
    this.isSelect = !this.isSelect;
    this.sendSelections.emit({ select: null, id: null, name: null, nickname: null });
    this.listBinding.forEach(member => {
      member.select = this.isSelect;
      this.sendSelections.emit({
        id: member.id,
        user_id: member.user_id,
        name: member.name,
        nickname: member.leader_neackname,
        userLabel: member.userLabel,
        select: this.isSelect
      });
    });
  }

  public actionTable() {
    this.isOptions = !this.isOptions;
  }

  public sort(event: number, data) {
    this.sortItems.emit({ sortData: { sort: `${data.id}`, sort_order: this.sortType[event] } });
  }

}
